/**
 * platformFactsApi.ts - AutoDoc V2.
 * Faits de plateforme nominatifs récupérés en direct depuis Microsoft Graph
 * (app registrations + expiration secrets, Conditional Access, invités, SKUs…).
 */
import { apiFetch } from './apiClient';

export interface AppCredential { type: 'secret' | 'certificate'; name?: string; endDateTime?: string; daysToExpiry?: number | null; }
export interface AppRegistration {
  displayName:    string;
  appId:          string;
  signInAudience: string;
  credentials:    AppCredential[];
  hasExpiredCred: boolean;
  hasSoonCred:    boolean;
}

export interface PlatformFacts {
  organization?: {
    displayName?: string; tenantId?: string; country?: string;
    createdDateTime?: string; onPremisesSyncEnabled?: boolean;
    verifiedDomains?: { name: string; isDefault: boolean; isInitial: boolean }[];
  } | null;
  users?: { total?: number | null; guests?: number | null } | null;
  appRegistrations?: { count: number; expiredCredApps: number; soonCredApps: number; items: AppRegistration[] } | null;
  conditionalAccess?: { count: number; enabled: number; items: { displayName: string; state: string }[] } | null;
  globalAdmins?: { count: number } | null;
  licenses?: { count: number; items: { skuPartNumber: string; enabled: number; consumed: number }[] } | null;
}

export interface PlatformFactsResponse {
  success:   boolean;
  tenantId?: string;
  runAt?:    string;
  facts?:    PlatformFacts;
  warnings?: { fact: string; code?: number; error?: string }[];
  error?:    string;
  hint?:     string;
}

export const platformFactsApi = {
  get: () => apiFetch<PlatformFactsResponse>('/platform-facts'),
};
